import { SvgIcon, type SvgIconProps } from './svgIcon'

export function FileCopyIcon({
  width = 24,
  height = 24,
  ...props
}: SvgIconProps) {
  return (
    <SvgIcon width={width} height={height} viewBox="0 0 19 22" {...props}>
      <path
        d="M4.5 17.5V0.5H13.25L18.5 5.74995V17.5H4.5ZM12.5 6.49995V1.99998H5.99998V16H17V6.49995H12.5ZM0.5 21.5V6.49998H1.99998V20H12.5V21.4999L0.5 21.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
